import { Button, ConfigProvider, Typography } from "antd";
import { DEFAULT_CUSTOMIZATION } from "store/tenancyCustomization/constants";
import { getContrastColor } from "theme/helpers";

interface IPageFooterProps {
    sloganFooter?: string;
    colors?: {
        colorHeaderFooter?: string;
        colorNavigationFont?: string;
    };
    testId?: string;
}

const PageFooter = ({ sloganFooter, colors, testId }: IPageFooterProps) => {
    const footerColor = getContrastColor(colors?.colorHeaderFooter || DEFAULT_CUSTOMIZATION.colorHeaderFooter);

    return (
        <ConfigProvider
            theme={{
                token: {
                    fontSize: 12,
                    colorPrimary: colors?.colorNavigationFont || DEFAULT_CUSTOMIZATION.colorNavigationFont,
                    colorLink: footerColor,
                    colorLinkHover: `${footerColor}CC`,
                    colorLinkActive: `${footerColor}FF`,
                },
            }}
        >
            <div
                className="page-footer flex w-full items-center justify-between gap-2 px-4 py-2"
                data-testid={testId}
                style={{
                    backgroundColor: colors?.colorHeaderFooter || DEFAULT_CUSTOMIZATION.colorHeaderFooter,
                    color: footerColor,
                }}
            >
                <Typography className="px-2" style={{ color: footerColor }}>
                    {sloganFooter || DEFAULT_CUSTOMIZATION.sloganFooter}
                </Typography>
                <div className="flex items-center gap-2">
                    <Button type="link" size="small" href="https://www.pretectum.com/" target="_blank" rel="noopener noreferrer">
                        Pretectum
                    </Button>
                    <Button type="link" size="small" href="https://www.pretectum.com/documentation-getting-started/" target="_blank" rel="noopener noreferrer">
                        Documentation
                    </Button>
                    <Button type="link" size="small" href="https://www.pretectum.com/about-us/privacy-policy/" target="_blank" rel="noopener noreferrer">
                        Privacy
                    </Button>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default PageFooter;
